import styled from "styled-components";

export const LottieContainer = styled.div(({ theme }) => ({
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    pointerEvents: "none",
    borderRadius: theme.cornerRadius.medium,
    overflow: "hidden",
}));
